/* eslint-disable no-console */
<template>
  <div class="material-list-box-wrapper" v-show="show">
    <div :class="{main: true,min: !config.showMore}">
      <img class="close" @click="close" src="../../assets/img/common/close.svg" alt="">
      <div class="top-wrapper">
        <div class="left">
          <div v-if="config.materialChannel == 'myMaterial'" class="title">我的素材</div>
          <div v-else class="title">素材库</div>
          <div v-show="config.showMore" class="chosen-number">
            (最多选择 1 个素材，已选择{{num}}个素材)
          </div>
        </div>
        <globalFilter ref="globalFilter" />
      </div>
      <!-- <div class="mediaType-container">
        <ul>
          <li :class="{on: mediaType == ''}" @click="mediaType = '';allLoaded = false;getList('init')">全部</li>
          <li :class="{on: mediaType == 1}" @click="mediaType = 1;allLoaded = false;getList('init')">图片</li>
          <li :class="{on: mediaType == 2}" @click="mediaType = 2;allLoaded = false;getList('init')">视频</li>
          <li :class="{on: mediaType == 3}" @click="mediaType = 3;allLoaded = false;getList('init')">音频</li>
        </ul>
      </div> -->
      <div ref="listContainer" class="list-container" :class="{empty:list&&!list.length,loading:loadingMore}" @scroll="getScroll($event)">
        <empty v-if="list && list.length === 0&&!loadingMore" :msg="'暂无素材'" />
        <ul ref="list" class="list-content ">
          <li v-if="config.showMore" v-for="(item,index) in list" @click="selectOne(index)" :key="index" :class="{list: true, on: item.status}">
            <div class="cover">
              <!-- todo 22 -->
              <!-- 如果是 之前有结果，然后正在重新识别 判断条件需要改变-->
              <div class='verify-success verify-item' v-if="item.has_audit&&item.has_audit==1&&+item.type === 2">
                <img class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                技审通过
              </div>
              <div class='verify-fail verify-item' v-if="item.has_audit&&item.has_audit==2&&+item.type === 2">
                <img class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
                技审未通过
              </div>
              <div class="bg" :style="{'background-image': `url(${item.cover ||(+item.type==3?defaultAudioImg: defaultImg)})`}"></div>

              <img v-show="+item.type >1" class="playBtn" src="@assets/img/index/play.svg" alt="">
              <img v-show="item.is_new-0 === 1&&item.status === false" class="newIcon" src="@assets/img/common/new-bold.svg" alt="">
              <!-- <div v-show="config.showMore" @click.stop="item.status=!item.status;calcSelect()" :class="{selectIcon: true, on: item.status}"></div> -->
              <div v-show="config.showMore" @click.stop="selectOne(index)" :class="{selectIcon: true, on: item.status}"></div>
              <div @click.stop="openDetail(item)" class="preview">预览</div>
            </div>
            <div class="detail">
              <p class="title">
                <img v-show="item.type-0 === 1" src="@assets/img/common/imgIcon.svg" alt="img">
                <img v-show="item.type-0 === 3" src="@assets/img/common/audioIcon.svg" alt="img">
                <img v-show="item.type-0 === 2" src="@assets/img/common/videoIcon.svg" alt="img">
                <span v-html="item.title"></span>
              </p>
            </div>
          </li>
          <li v-if="!config.showMore" v-for="(item,index) in list" @click.stop="selectCover(item.id,item.cover)" :key="index" :class="{list: true, on: item.status}">
            <div class="cover">
              <!-- todo 22 -->
              <!-- 如果是 之前有结果，然后正在重新识别 判断条件需要改变-->
              <div class='verify-success verify-item' v-if="item.has_audit&&item.has_audit==1&&+item.type === 2">
                <img class="verify-logo" src="@assets/img/common/verify-success-logo.svg">
                技审通过
              </div>
              <div class='verify-fail verify-item' v-if="item.has_audit&&item.has_audit==2&&+item.type === 2">
                <img class="verify-logo" src="@assets/img/common/verify-fail-logo.svg">
                技审未通过
              </div>
              <div class="bg" :style="{'background-image': `url(${item.cover ||(+item.type==3?defaultAudioImg: defaultImg)})`}"></div>

              <img v-show="+item.type >1" class="playBtn" src="@assets/img/index/play.svg" alt="">
              <img v-show="item.is_new-0 === 1&&item.status === false" class="newIcon" src="@assets/img/common/new-bold.svg" alt="">
              <div v-show="config.showMore" @click.stop="item.status=!item.status;calcSelect()" :class="{selectIcon: true, on: item.status}"></div>
              <div @click.stop="openDetail1(item)" class="preview">预览</div>
            </div>
            <div class="detail">
              <p class="title">
                <img v-show="item.type-0 === 1" src="@assets/img/common/imgIcon.svg" alt="img">
                <img v-show="item.type-0 === 3" src="@assets/img/common/audioIcon.svg" alt="img">
                <img v-show="item.type-0 === 2" src="@assets/img/common/videoIcon.svg" alt="img">
                <span v-html="item.title"></span>
              </p>
            </div>
          </li>
          <li class="fillItem" :style="{height: 0, width: `${fillWidth}px`}"></li>
        </ul>
        <div class="loading-wrapper" v-if="loadingMore">
          <div class="loadEffect">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
          正在加载...
        </div>
      </div>

      <div v-if="list&&list.length&&config.showMore" class="confirm-box">
        <div class="confirm item" @click="addFile">
          确定
        </div>
        <div class="cancel item" @click="cancle">
          取消
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "@common/common";
import { apis } from "@common/config";
import empty from "@components/empty";
import globalFilter from "@components/globalFilter";
import store from "@common/store";

export default {
  name: "MaterialListBox",
  data() {
    return {
      mediaType: '2',
      showMore: true,
      show: true,
      config: {},
      detail: {},
      r: null,
      page: {
        pageSize: 50,
        pageIndex: 0
      },
      typeIndex: "",
      dateIndex: "",
      start: "",
      end: "",
      loadingMore: false,
      list: [],
      fillWidth: 0,
      itemHeight: 0,
      defaultImg: require("@assets/img/common/default.png"),
      defaultAudioImg: require("@assets/img/common/audioMask.jpg"),
      num: 0,
      reachBottom: false,
      timer: null,
      searchOptions: {}
    };
  },
  //   computed:{
  // reachBottom(){
  //   return this.gap>
  // }
  //   },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    // this.$watch(
    //   reachBottom,
    //   this.debounce(() => {
    //     // this.loadMore
    //     this.getList();
    //   }, 500)
    // );
  },
  methods: {
    selectOne(index) {
      this.list.forEach((val,key) => {
        if(key == index){
          val.status = !val.status
        }else{
          val.status = false
        }
      })
      this.calcSelect()
    },
    selectCover(id,cover) {
      if(!this.config.showMore){
        console.log(id,this.config.showPhotoEdit)
        if(this.config.showPhotoEdit){
          let media = {
            id: id,
            cover: cover
          }
          this.cancle();
          this.r && this.r(media);
        }else{
          let param = {
            file_ids: id,
            ...this.config
          };

          let media = {
            id: id,
            cover: cover
          }
          // console.log(param)
          // return false;
          common
            .myFetch(apis.File_bind, param)
            .then(result => {
              console.log("File_add 关联稿件", result);
              // 成功响应
              if (result) {
                this.$toast("添加素材成功");
                this.cancle();
                this.r && this.r(media);
              }
            })
            .catch(e => {
              console.log("关联素材到文稿失败 e", e);
          });
        }
      }
    },
    openDetail1(item) {
      if(this.config.link){
          // let config = {
          //   type: item.type,
          //   id: item.id,
          //   quickEdit: this.config.quickEdit,
          //   create: this.config.create,
          //   canEdit: false,
          //   t: 5,
          //   d: this.config.d
          // };

          let mediaDetailConfig = {
            quickEdit: this.config.quickEdit,
            create: this.config.create,
            canEdit: false
          }

          mediaDetailConfig = JSON.stringify(mediaDetailConfig)

          store.commit("setDetailConfig", mediaDetailConfig);

          common.jump('/mediaDetail?type='+item.type+'&id='+item.id+'&t=5&d='+this.config.d,true)
        }else{
          let config = {
            type: item.type,
            id: item.id,
            quickEdit: this.config.quickEdit,
            create: this.config.create,
            canEdit: false,
            t: 5,
            d: this.config.d
          };

          this.$materialBox(config);
        }
    },
    openDetail(item) {
      if(this.config.showMore){
        // console.log(this.$route)
        if(this.config.link){
          // let config = {
          //   type: item.type,
          //   id: item.id,
          //   quickEdit: this.config.quickEdit,
          //   create: this.config.create,
          //   canEdit: false,
          //   t: 5,
          //   d: this.config.d
          // };

          let mediaDetailConfig = {
            quickEdit: this.config.quickEdit,
            create: this.config.create,
            canEdit: false
          }

          mediaDetailConfig = JSON.stringify(mediaDetailConfig)

          store.commit("setDetailConfig", mediaDetailConfig);

          common.jump('/mediaDetail?type='+item.type+'&id='+item.id+'&t=5&d='+this.config.d,true)
        }else{
          let config = {
            type: item.type,
            id: item.id,
            quickEdit: this.config.quickEdit,
            create: this.config.create,
            canEdit: false,
            t: 5,
            d: this.config.d
          };

          this.$materialBox(config);
        }
      }else{
        if(this.config.onlyOne){
          console.log(1)
          this.r && this.r(item);
          this.cancle();
        }else{
          // console.log(item)
        let param = {
        file_ids: item.id,
        ...this.config
      };

      common
        .myFetch(apis.File_bind, param)
        .then(result => {
          console.log("File_add 关联稿件", result);
          // 成功响应
          if (result) {
            this.$toast("添加素材成功");
            this.cancle();
            this.r && this.r(item.cover);
          }
        })
        .catch(e => {
          console.log("关联素材到文稿失败 e", e);
        });
        }
      }
    },
    open(c, r, callback) {
      console.log(c)
      if(c.showMore){
        this.typeIndex = ""
      }else{
        this.typeIndex = 1
      }
      this.config = c;
      this.r = r;
      this.callback = callback;
      this.getList("init");
      // 禁止滚动 穿透
      window.document.body.classList.add("prevent-scroll");
      this.show = true;
    },
    close() {
      this.allLoaded = false;
      this.loadingMore = false;
      this.searchOptions = {};
      window.document.body.classList.remove("prevent-scroll");
      this.show = false;
    },
    cancle() {
      this.num = 0;
      this.page.pageIndex = 0;
      this.list = this.list.map(e => {
        e.status = false;
        return e;
      });
      this.close();
    },
    getList(hint) {
      if (this.loadingMore) return;
      console.log("getList hint", hint);
      this.loadingMore = true;
      let data = {
        page: ["search", "init"].includes(hint) ? 1 : this.page.pageIndex + 1,
        pagesize: this.page.pageSize,
        key_words: "",
        search_option: "",
        type: this.config.showMore ? this.mediaType : 1,
        days: this.dateIndex,
        start: this.start,
        end: this.end,
        has_file: this.config.showMore ? this.mediaType : 1
      };
      let type = {
        pageType: 'file'
      }
      let param = {
        ...data,
        ...this.searchOptions,
        ...type
      };
      console.log("param", param);
      console.log("search_option", this.searchOptions);
      console.log(this.config.materialChannel)
      if(this.config.materialChannel == 'myMaterial'){
        return common
        .myFetch(apis.File_myFile, { data: param, hideLoading: true })
        .then(res => {
          if (res) {
            console.log("File_myFile res", res.list);
            res.list.forEach(el => {
              el.status = false;
            });
            if (hint == "init" || hint == "search") {
              this.num = 0;
              this.list = res.list;
              this.page.pageIndex = 1;
            } else {
              if (res.list && res.list.length) {
                this.list = [...this.list, ...res.list];
                this.page.pageIndex++;
              }
            }
            // 当有数据的时候，才让分页+1

            if (!res || !res.list || !res.list.length) {
              console.log("getList 没有res.list");
              this.allLoaded = true;
            }
            this.loadingMore = false;
            this.generateSearchs(res.params.top_search.option.list);
          }
        });
      }else{
        return common
        .myFetch(apis.Index_search, { data: param, hideLoading: true })
        .then(res => {
          if (res) {
            // console.log("File_myFile res", res.list);
            res.list.forEach(el => {
              el.status = false;
            });
            if (hint == "init" || hint == "search") {
              this.num = 0;
              this.list = res.list;
              this.page.pageIndex = 1;
            } else {
              if (res.list && res.list.length) {
                this.list = [...this.list, ...res.list];
                this.page.pageIndex++;
              }
            }
            // 当有数据的时候，才让分页+1

            if (!res || !res.list || !res.list.length) {
              console.log("getList 没有res.list");
              this.allLoaded = true;
            }
            this.loadingMore = false;
            this.generateSearchs(res.params.top_search.option.list);
          }
        });
      }
    },
    generateSearchs(data) {
      // console.log("generateSearchs data", data);
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.$refs.globalFilter.getData(filterData);
    },
    getSearch(d) {
      console.log("getSearch d", d);
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 0;
      // 让list回到顶部
      this.$refs.listContainer.scrollTop = 0;
      this.getList("search");
    },
    calcSelect() {
      let num = 0;
      this.list.forEach(el => {
        if (el.status) {
          num++;
        }
      });
      this.num = num;
      // console.log("num", num);
    },
    calcFillWidth() {
      // console.log(999)
      // 计算填充元素宽度
      const list = this.$refs.list;
      if (!list || !list.getBoundingClientRect()) return;
      const listWidth = list.getBoundingClientRect().width;
      let fillWidth = 0;
      const itemWidth = 242; // item dom宽度
      const itemGap = 6; //item 边距
      const listGap = 15; // list左右边距
      const countsPerPage = this.list.length || 20; //每页的item数量
      const containerWidth = listWidth - listGap; //容器实际宽度（dom宽度 - 左右padding）
      const countsPerRow = parseInt(containerWidth / (itemWidth + itemGap)); //每行item数量
      const countsLastLine = countsPerPage % countsPerRow || countsPerRow; //最后一行的item数量
      // const itemRatio = 284.5 / 255;
      const itemRatio = 210 / 242;
      const itemWidthNow = (listWidth - listGap) / countsPerRow - itemGap;
      const itemHeightNow = itemWidthNow * itemRatio;

      fillWidth =
        countsPerRow === countsLastLine
          ? 0
          : (countsPerRow - countsLastLine) * (itemWidthNow + itemGap);
      console.log("calcFillWidth-listWidth", listWidth);
      console.log("countsLastLine", countsLastLine);
      this.fillWidth = fillWidth;
      this.itemHeight = itemHeightNow;
      console.log("itemHeight", itemHeightNow);
      console.log("itemWidthNow", itemWidthNow);
      // console.log('list', itemWidthNow, itemHeightNow, countsPerRow, fillWidth)
    },
    /**
     * 关联素材到稿件
     */
    addFile() {
      if(this.mediaType == 2){
        if(this.config.selectPlatform != 'b_plus' && this.config.selectPlatform != 'dy'){
          console.log(999,this.list)
          let videoInfo = ''
          this.list.forEach(el => {
            if(el.status && el.content && el.content.resolution){
              let arr = el.content.resolution.split('x')
              if(arr[0] > arr[1]){
                  videoInfo = '16:9'
              }else{
                  videoInfo = '9:16'
              }
            }
          })
          console.log(123)
          this.$MediaPlatformWater(this.config.logoList,videoInfo).then(res => {
            if(res != 99999){
              let file_ids = this.list
                .filter(e => e.status)
                .map(e => e.id)
                .join(",")
                let param = {
                  file_ids: file_ids,
                  ...this.config,
                  logo_key: this.config.logoList[res].logo_key
                };

                // console.log(param)
                // return false;
                common
                  .myFetch(apis.File_bind, param)
                  .then(result => {
                    console.log("File_add 关联稿件", result);
                    // 成功响应
                    // return false;
                    if (result) {
                      this.$toast("添加素材成功");
                      this.cancle();
                      this.r && this.r({id: result.id, index: res});
                    }
                  })
                  .catch(e => {
                    console.log("关联素材到文稿失败 e", e);
                });
            }
          })
        }else{
          console.log(this.config.logoList)
          let file_ids = this.list
                .filter(e => e.status)
                .map(e => e.id)
                .join(",")
                let param = {
                  file_ids: file_ids,
                  ...this.config,
                };

                if(this.config.selectPlatform == 'dy' && this.config.logoList && this.config.logoList.length > 0){
                  param.logo_key = this.config.logoList[0].logo_key
                  common
                    .myFetch(apis.File_bind, param)
                    .then(result => {
                      // console.log("File_add 关联稿件", result);
                      // 成功响应
                      // return false;
                      if (result) {
                        this.$toast("添加素材成功");
                        this.cancle();
                        this.r && this.r({id: result.id, index: 0});
                      }
                    })
                    .catch(e => {
                      console.log("关联素材到文稿失败 e", e);
                  });
                }else{
                  common
                    .myFetch(apis.File_bind, param)
                    .then(result => {
                      // console.log("File_add 关联稿件", result);
                      // 成功响应
                      // return false;
                      if (result) {
                        this.$toast("添加素材成功");
                        this.cancle();
                        this.r && this.r({id: file_ids, index: 999});
                      }
                    })
                    .catch(e => {
                      console.log("关联素材到文稿失败 e", e);
                  });
                }

                // console.log(param)
                // return false;
        }
      }else{
        const status = true;
        if(status){
          let file_ids = this.list
              .filter(e => e.status)
              .map(e => e.id)
              .join(",")
          let param = {
            file_ids: file_ids,
            ...this.config
          };

          // console.log(param)
          // return false;
          common
            .myFetch(apis.File_bind, param)
            .then(result => {
              console.log("File_add 关联稿件", result);
              // 成功响应
              if (result) {
                this.$toast("添加素材成功");
                this.cancle();
                this.r && this.r(file_ids);
              }
            })
            .catch(e => {
              console.log("关联素材到文稿失败 e", e);
          });
        }
      }
    },
    checkFileCount(files) {
      console.log(files)
      // 检查素材数量，每种素材都不超过10个才能通过检查
      let status = true;
      // const imgs = []
      const videos = [];
      const audios = [];
      files.forEach(i => {
        if(i.status){
          let ext = i.title.split(".").pop();
          ext = ext.toLowerCase();
          i.ext = ext;
          if (this.config.video.types.indexOf(ext) > -1) {
            videos.push(i);
          } else if (this.config.audio.types.indexOf(ext) > -1) {
            audios.push(i);
          }
        }
      });

      console.log(videos,audios)

      // const imgStatus = this.checkImgCount(imgs)
      const videoStatus = this.checkVideoCount(videos);
      const audioStatus = this.checkAudioCount(audios);

      status = videoStatus && audioStatus;

      if (!status) {
        this.$toast("音视频素材不能超过10个");
      }

      return status;
    },
    checkVideoCount(videos) {
      // 检测视频数量
      console.log(this.config.list)
      let status = true;
      const queuelength = this.config.list.filter(
        i => this.config.video.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.config.video.assets.length;
      const selectlength = videos.length;
      if (queuelength + assetslength + selectlength > 10) {
        status = false;
      }

      return status;
    },
    checkAudioCount(audios) {
      // 检测音频数量
      let status = true;
      const queuelength = this.config.list.filter(
        i => this.config.audio.types.indexOf(i.ext) > -1 && !i.hideasset
      ).length;
      const assetslength = this.config.audio.assets.length;
      const selectlength = audios.length;
      if (queuelength + assetslength + selectlength > 10) {
        status = false;
      }

      return status;
    },
    async getScroll(e) {
      if (e) {
        let containerH = 630 - 80 - 40 - 60;
        let scrollTop = e.target.scrollTop;
        let listHeight = this.$refs.list.offsetHeight;
        console.log("getScroll");
        if (scrollTop + containerH >= listHeight) {
          if (this.allLoaded) {
            console.log("进入allLoaded分支");
            return e.preventDefault();
          } else {
            console.log("getScroll 拿分页");
            this.getList();
          }
        }
      }
    },
    loadMore() {
      if (!this.loadingMore) {
        console.log("再次分页加载");
        this.loadingMore = true;
        this.getList();
      }
    }
  },

  components: { globalFilter, empty }
};
</script>

<style lang='less'>
.prevent-scroll {
  height: 100%;
  overflow: hidden;
}
.loading-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangTC-Medium;
  font-size: 14px;
  color: #829191;
  height: 30px;
  .loadEffect {
    width: 100px;
    height: 100px;
    position: relative;
    transform: scale(0.3);
    margin-right: -25px;
  }
  .loadEffect span {
    display: inline-block;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: #41b48c;
    position: absolute;
    -webkit-animation: load 1.04s ease infinite;
  }
  @-webkit-keyframes load {
    0% {
      -webkit-transform: scale(1.2);
      opacity: 1;
    }
    100% {
      -webkit-transform: scale(0.3);
      opacity: 0.5;
    }
  }
  .loadEffect span:nth-child(1) {
    left: 0;
    top: 50%;
    margin-top: -10px;
    -webkit-animation-delay: 0.13s;
  }
  .loadEffect span:nth-child(2) {
    left: 14px;
    top: 14px;
    -webkit-animation-delay: 0.26s;
  }
  .loadEffect span:nth-child(3) {
    left: 50%;
    top: 0;
    margin-left: -10px;
    -webkit-animation-delay: 0.39s;
  }
  .loadEffect span:nth-child(4) {
    top: 14px;
    right: 14px;
    -webkit-animation-delay: 0.52s;
  }
  .loadEffect span:nth-child(5) {
    right: 0;
    top: 50%;
    margin-top: -10px;
    -webkit-animation-delay: 0.65s;
  }
  .loadEffect span:nth-child(6) {
    right: 14px;
    bottom: 14px;
    -webkit-animation-delay: 0.78s;
  }
  .loadEffect span:nth-child(7) {
    bottom: 0;
    left: 50%;
    margin-left: -10px;
    -webkit-animation-delay: 0.91s;
  }
  .loadEffect span:nth-child(8) {
    bottom: 14px;
    left: 14px;
    -webkit-animation-delay: 1.04s;
  }
}
</style>
<style lang="less" scoped>
@import "../../assets/css/global.less";

.mediaType-container {
  width: 100%;
  height: 40px;
  background: #F3F4F5;
  padding: 0 30px;
  box-sizing: border-box;
  margin-top: 20px;

  ul {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;

    li {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 14px;
      color: #829191;
      margin-right: 8px;
      user-select: none;
      cursor: pointer;

      &.on {
        color: @green;
        border: 1px solid @green;
        box-sizing: border-box;
        border-radius: 20px;
      }
    }
  }
}

.material-list-box-wrapper {
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
  z-index: 100000001;
  background-color: rgba(#000, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  .main {
    position: relative;
    width: 1064px;
    height: 630px;
    padding: 16px 30px 20px;
    background-color: #fff;
    border-radius: 4px;

    &.min {
      height: 558px;
    }
  }
  .top-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: 30px;
    .left {
      display: flex;
      align-items: center;
    }
    .title {
      font-family: PingFang-SC-Bold;
      font-size: 24px;
      color: #050f0f;
    }
    .chosen-number {
      font-family: PingFang-SC-Bold;
      font-size: 14px;
      color: #b9c3c3;
      margin-left: 10px;
    }
  }
  .close {
    position: absolute;
    right: 40px;
    top: 20px;
    width: 17px;
    height: 17px;
  }
}
.list-container {
  margin: 24px 0 20px;
  overflow-y: auto;
  height: calc(630px - 180px);
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 4px;
  }
  &.empty {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .list-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    justify-content: start;
    position: relative;
    overflow-y: auto;

    .list {
      margin-right: 12px;
      display: flex;
      flex-direction: column;
      width: 240px;
      border-radius: 4px;
      border: 1px solid #dcdcdc;
      margin-bottom: 30px;
      box-sizing: border-box;
      &:nth-child(4n) {
        margin-right: 0;
      }
      &.on {
        background-color: rgba(185, 195, 195, 0.2);
      }

      .preview {
        display: none;
        position: absolute;
        top: 8px;
        left: 8px;
        width: 48px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        background: rgba(90,90,90,0.7);
        border-radius: 12px;
        font-size: 14px;
        color: #FFFFFF;
        user-select: none;
        cursor: pointer;

        &:hover {
          background: rgba(65,180,140,0.7);
        }
      }

      .verify-item {
        position: absolute;
        right: 0;
        bottom: 6px;
        background-color: rgba(@green, 0.5);
        line-height: 18px;
        border-radius: 50px 0 0 50px;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        font-size: 10px;
        font-weight: 700px;
        color: white;
        padding: 0 8px;
        &.verify-fail {
          background-color: rgba(#ff3e53, 0.5);
        }
        img {
          width: 11px;
          margin-right: 4px;
        }
      }
      .cover {
        position: relative;
        display: flex;
        width: 100%;
        height: 135px;
        // flex: 1;

        .bg {
          width: 100%;
          height: 100%;
          overflow: hidden;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }

        .playBtn {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          margin: auto;
          width: 40px;
          height: auto;
        }

        .newIcon {
          position: absolute;
          top: 6px;
          right: 7px;
        }

        .selectIcon {
          display: none;
          position: absolute;
          top: 8px;
          right: 8px;
          width: 24px;
          height: 24px;
          border-radius: 12px;
          background-color: rgba(90, 90, 90, 0.7);
          user-select: none;
          cursor: pointer;

          &::after {
            position: absolute;
            top: 50%;
            left: 50%;
            margin-left: -7px;
            margin-top: -5.5px;
            content: "";
            display: block;
            width: 14px;
            height: 11px;
            background: url("../../assets/img/material/checked.svg") no-repeat;
            background-position: center center;
            background-size: 100% 100%;
          }

          &.on {
            display: block;
            background-color: @green;
            &::after {
              position: absolute;
              top: 50%;
              left: 50%;
              margin-left: -7px;
              margin-top: -5.5px;
              content: "";
              display: block;
              width: 14px;
              height: 11px;
              background: url("../../assets/img/material/checked.svg") no-repeat;
              background-position: center center;
              background-size: 100% 100%;
            }
          }
        }
      }

      & > .detail {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;
        // height: 135px;
        padding: 10px 10px 12px;
        box-sizing: border-box;

        .title {
          font-size: 18px;
          height: 48px;
          min-height: 48px;
          line-height: 24px;
          font-weight: bold;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          word-break: break-all;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
        }

        .detail {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;

          p {
            display: flex;
            flex-direction: row;
            align-items: center;
            font-size: 14px;
            line-height: 18px;
            color: #b9c3c3;
            margin-bottom: 4px;
            min-width: 50%;

            &.clock {
              font-weight: bold;
              font-family: Arial;
            }

            &.share {
              display: flex;
              justify-content: flex-end;
            }

            &:nth-last-of-type(1) {
              margin-bottom: 0;
            }
          }
        }

        .edit {
          display: none;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          padding: 0 30px;
          box-sizing: border-box;

          div {
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: pointer;
            user-select: none;

            img {
              margin-right: 10px;
            }

            span {
              font-size: 14px;
              line-height: 18px;
              color: #41b48c;
            }
          }

          .line {
            width: 1px;
            height: 20px;
            background: #e6e6e6;
          }
        }
      }

      &:hover {
        border: 2px solid @green;
        box-sizing: border-box;

        .detail {
          box-sizing: border-box;

          .detail {
            display: none;
          }

          .edit {
            display: flex;
          }
        }

        .newIcon {
          display: none;
        }

        .selectIcon {
          display: block;
        }

        .preview {
          display: block;
        }
      }
    }
  }
}
.confirm-box {
  display: flex;
  align-items: center;
  justify-content: center;
  .item {
    width: 120px;
    height: 40px;
    line-height: 40px;
    color: white;
    background-color: #41b48c;
    border-radius: 25px;
    text-align: center;
    user-select: none;
    cursor: pointer;
    &.cancel {
      background-color: #b9c3c3;
      margin-left: 20px;
    }
  }
}
.mask {
  background-color: #000;
  opacity: 0.7;
}
</style>
